var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiddenfeesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_334_386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.702 14.5202C32.197 13.2576 31.4394 12.2727 30.4545 11.5404C29.4697 10.8081 28.2828 10.4545 26.8939 10.4545C26.1364 10.4545 25.404 10.5556 24.6717 10.7828C23.9394 11.0101 23.3081 11.3889 22.702 11.9949L19.0404 8.33333C19.6212 7.75253 20.4293 7.19697 21.4394 6.71717C22.4495 6.23737 23.3838 5.93434 24.2172 5.80808V0.505051H29.2677V5.68182C31.1616 6.06061 32.8283 6.81818 34.2677 7.9798C35.7071 9.14141 36.7677 10.6313 37.5 12.5L32.702 14.5202ZM46.4646 50L34.8485 38.3838C34.2172 39.0152 33.3586 39.5202 32.2475 39.9242C31.1364 40.3283 30.1515 40.5556 29.2677 40.6566V45.9596H24.2172V40.5303C21.8687 39.9495 19.899 38.8636 18.3081 37.298C16.7172 35.7323 15.5808 33.7879 14.8737 31.4141L19.9242 29.3939C20.4293 31.1616 21.2879 32.6768 22.4747 33.9394C23.6616 35.202 25.2525 35.8333 27.2475 35.8333C28.0051 35.8333 28.7121 35.7323 29.3434 35.5556C29.9747 35.3788 30.5808 35.0758 31.1869 34.697L0 3.53535L3.53535 0L50 46.4646L46.4646 50Z",
    fill: "#142862"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_334_386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenfeesIcon);
export default __webpack_public_path__ + "static/media/hiddenfees_icon.681fac9e1cdda931c3bde05cf9ed3bd0.svg";
export { ForwardRef as ReactComponent };